/**
 * documentation at
 * https://webartelier.de/fee_doc/list_classes.html#slider
 */


class Slider {

  static init = (params) => {
    const selSlider = `${params.selSlider}:not(.is-initialized)`;
    const allSliders = document.querySelectorAll(selSlider);

    allSliders.forEach(slider => {
      new Slider(slider, params);
    })
  }



  constructor(slider, params) {
    this.allConfigs = params.config;
    this.slider = slider;
    this.generateRandomString = params.generateRandomString;

    this.type = '';
    this.uniqueString = '';
    this.uniqueClass = '';
    this.config = {};
    this.clonedConfig = {};

    this.initSlider();
  }



  initSlider = () => {
    this.type = this.slider.dataset.type;

    if (!this.type) {
      this.handleMissingSliderType();
      return;
    }

    this.uniqueClass = this.makeUnique();
    this.config = this.editConfig();
    this.markInitialized();
    
    new Swiper(this.slider, this.clonedConfig);
  }



  markInitialized = () => {
    this.slider.classList.add(this.uniqueClass, 'is-initialized');
  }



  makeUnique = () => {
    const uniqueString = this.generateRandomString(10);
    const uniqueClass = `slider-${uniqueString}`;
    return uniqueClass;
  }



  editConfig = () => {
    this.config = this.allConfigs[this.type];

    if (!this.config) {
      this.handleMissingConfig();
      return;
    }

    this.clonedConfig = JSON.parse(JSON.stringify(this.config));
    this.editNavigation();
    this.editPagination();
  }



  editNavigation = () => {
    if (!this.clonedConfig['navigation']) return false;

    const prevElement = this.clonedConfig['navigation']['prevEl'];
    const nextElement = this.clonedConfig['navigation']['nextEl'];
    const newPrevElement = `.${this.uniqueClass} ${prevElement}`;
    const newNextElement = `.${this.uniqueClass} ${nextElement}`;
    this.clonedConfig['navigation']['prevEl'] = newPrevElement;
    this.clonedConfig['navigation']['nextEl'] = newNextElement;
  }



  editPagination = () => {
    if (!this.clonedConfig['pagination']) return false;

    const paginationElement = this.clonedConfig['pagination']['el'];
    const newPaginationElement = `.${this.uniqueClass} ${paginationElement}`;
    this.clonedConfig['pagination']['el'] = newPaginationElement;
  }



  handleMissingSliderType = () => {
    console.warn('Missing slider type - initialization failed!');
  }



  handleMissingConfig = () => {
    console.warn(`Missing configuration for ${this.uniqueClass}`);
  }
}